import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/footer-ultra-modern.css';

const Footer = () => {
  const { t, renderKey } = useLanguage();
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [particles, setParticles] = useState([]);

  // Crear partículas animadas
  useEffect(() => {
    const createParticles = () => {
      const newParticles = [];
      for (let i = 0; i < 15; i++) {
        newParticles.push({
          id: i,
          x: Math.random() * 100,
          y: Math.random() * 100,
          size: Math.random() * 4 + 1,
          delay: Math.random() * 5,
          duration: Math.random() * 10 + 10
        });
      }
      setParticles(newParticles);
    };
    
    createParticles();
  }, []);

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate newsletter subscription
    setTimeout(() => {
      console.log('Newsletter subscription:', email);
      setEmail('');
      setIsSubmitting(false);
      
      // Show success message with animation
      const successMsg = document.createElement('div');
      successMsg.textContent = t('footer.subscriptionSuccess');
      successMsg.className = 'success-toast';
      document.body.appendChild(successMsg);
      
      // Animate in
      setTimeout(() => successMsg.classList.add('show'), 100);
      
      // Remove after animation
      setTimeout(() => {
        successMsg.classList.remove('show');
        setTimeout(() => {
          if (document.body.contains(successMsg)) {
            document.body.removeChild(successMsg);
          }
        }, 300);
      }, 3000);
    }, 1000);
  };

  return (
    <footer className="footer-ultra-modern" key={renderKey}>
        {/* Partículas de fondo animadas */}
        <div className="footer-particles">
          {particles.map((particle) => (
            <div
              key={particle.id}
              className="particle"
              style={{
                left: `${particle.x}%`,
                top: `${particle.y}%`,
                width: `${particle.size}px`,
                height: `${particle.size}px`,
                animationDelay: `${particle.delay}s`,
                animationDuration: `${particle.duration}s`
              }}
            />
          ))}
        </div>

        {/* Onda superior animada */}
        <div className="footer-wave-top">
          <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" />
          </svg>
        </div>

        <div className="footer-container-modern">
          
          {/* Sección principal del footer */}
          <div className="footer-main-modern">
            
            {/* Sección izquierda - Logo y tagline */}
            <div className="footer-brand-section">
              <div className="logo-container-ultra">
                <div className="logo-glow-effect">
                  <img src={`/amb-tu-logo-new.png`} alt="Amb Tu" className="logo-ultra-modern" />
                </div>
                <div className="logo-text-container">
                  <h2 className="brand-name-ultra">Amb Tu</h2>
                  <div className="tagline-ultra">
                    <p className="tagline-line-1">{t('footer.tagline1')}</p>
                    <p className="tagline-line-2">{t('footer.tagline2')}</p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Sección derecha - Enlaces compactos */}
            <div className="footer-links-section">
              <div className="footer-links-grid">
                <div className="links-column">
                  <h4 className="links-title">{t('footer.quickLinks')}</h4>
                  <div className="links-list">
                    <a href="#dashboard" className="footer-link">{t('footer.dashboard')}</a>
                    <a href="#analytics" className="footer-link">{t('footer.analytics')}</a>
                    <a href="#campaigns" className="footer-link">{t('footer.campaigns')}</a>
                    <a href="#reports" className="footer-link">{t('footer.reports')}</a>
                  </div>
                </div>
                
                <div className="links-column">
                  <h4 className="links-title">{t('footer.support')}</h4>
                  <div className="links-list">
                    <a href="#help" className="footer-link">{t('footer.help')}</a>
                    <a href="#documentation" className="footer-link">{t('footer.documentation')}</a>
                    <a href="#contact" className="footer-link">{t('footer.contact')}</a>
                    <a href="#privacy" className="footer-link">{t('footer.privacy')}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Línea divisoria animada */}
          <div className="footer-divider-modern">
            <div className="divider-line"></div>
            <div className="divider-dots">
              {[...Array(5)].map((_, i) => (
                <div key={i} className="divider-dot" style={{ animationDelay: `${i * 0.2}s` }}></div>
              ))}
            </div>
          </div>
          
          {/* Sección inferior */}
          <div className="footer-bottom-modern">
            <div className="copyright-section">
              <span className="copyright-text">
                © {new Date().getFullYear()} {t('footer.copyright')}
              </span>
              <div className="copyright-highlight"></div>
            </div>
            
            <div className="footer-logo-mini">
              <div className="mini-logo-container">
                <img src={`/amb-tu-logo-new.png`} alt="Amb Tu" className="mini-logo" />
                <div className="mini-logo-glow"></div>
              </div>
            </div>
          </div>
        </div>
      </footer>
  );
};

export default Footer;